import { atom } from 'recoil';

const enterpriseGroupBuyFilterMealSearchFormAtom = atom<{
  storeIds: Array<string>;
  tags: Array<string>;
  searchText: string;
}>({
  key: 'enterpriseGroupBuyFilterMealSearchForm',
  default: {
    storeIds: [],
    tags: [],
    searchText: '',
  },
});

export default enterpriseGroupBuyFilterMealSearchFormAtom;
